<template>
  <footer class="landing-footer">
    <div class="powered-by-container">
      <span class="powered-by-text">Powered by</span>
      <span class="brand-name">MyCryptoBox</span>
    </div>
  </footer>
</template>

<script setup lang="ts">
</script>

<style scoped>
.landing-footer {
  padding: 37px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.powered-by-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}

.powered-by-text {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: rgba(255, 255, 255, 0.6);
}

.brand-name {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #FFFFFF;
}
</style>
